import { Devices } from '@/features/devices/components/Devices'
import { Page } from '@/ui-kit'

const DevicesPage = () => (
  <Page>
    <Devices />
  </Page>
)

export default DevicesPage
